export const PARTY_KIND = {
  PERSON: 'Person',
  PLACE: 'Place',
  VEHICLE: 'Vehicle',
};

export const PARTY_KIND_OPTIONS = [{ Code: PARTY_KIND.PERSON }, { Code: PARTY_KIND.PLACE }];
